import AdjustService from 'services/adjust.service';

export const adjustService = AdjustService.getInstance();

export const ADJUST_EVENTS = {
  RECHARGE: {
    EXISTING_USER_RECHARGE_HOME_SCREEN: 'p1d3k5',
    EXISTING_USER_SELECT_BALANCE_RECHARGE: 'ruoftw',
    EXISTING_USER_SELECT_RECHARGE_AMOUNT: '2cw16q',
    EXISTING_USER_CHECKOUT_CLICK: 'u90sps',
    EXISTING_USER_PAYMENT_METHOD_CONTINUE_CLICK: '1iw71s',
    EXISTING_USER_BALANCE_RECHARGE_CHECKOUT_CLICK: '92nin7',
    EXISTING_USER_RECHARGE_OTP_INITIATED: 'pw5pwe',
    EXISTING_USER_BALANCE_RECHARGE_OTP_VERIFY: 'pgyyn5',
    EXISTING_USER_BALANCE_RECHARGE_COMPLETE: 'xi6zza',
    EXISTING_USER_BALANCE_RECHARGE_FAILED: 'gflcuw',

  },
  JOIN: {
    NEW_USER_JOIN_LEBARA_HOME_SCREEN: '6zxsgo',
    NEW_USER_SELECT_PLAN: 'toxuuc',
    NEW_USER_SELECT_PLAN_DETAILS: 'tvecfb',
    NEW_USER_SIM_TYPE: 'rrze48',
    NEW_USER_CONFIRM_PLAN: 'xmac0q',
    NEW_USER_NEW_NUMBER: 'ud90sk',
    NEW_USER_CONFIRM_INFORMATION: 'qwmpf7',
    NEW_USER_CONFIRM_NUMBER: 'mhodi4',
    NEW_USER_ERROR_SCREEN: 'x4jr7i',
    NEW_USER_SUBMIT_NATIONAL_ID: 'pvym5w',
    NEW_USER_SUBMIT_NATIONALITY: 'd0gsuu',
    NEW_USER_SUBMIT_CONTACT_DETAILS: 'w4gw49',
    NEW_USER_OTP_VERIFY: '4yk3mr',
    NEW_USER_DELIVERY_ADDRESS_SUBMIT: 'bg09eq',
    NEW_USER_SIM_PICKUP_ADDRESS_SUBMIT: 'ay80c3',
    NEW_USER_CONFIRM_LOCATION: 'r3wrvg',
    NEW_USER_PROMO_CODE_APPLY: '28iwja',
    NEW_USER_CHECKOUT_CLICK: 'glw36w',
    NEW_USER_PAYMENT_METHOD_CONTINUE_CLICK: 'ahf5k9',
    NEW_USER_ORDER_COMPLETE: '3d3ygb',
    NEW_USER_PAYMENT_COMPLETED_WEB: "oe5xfv",
    NEW_USER_PAYMENT_FAILED: "pnqhcf",
    NEW_USER_ORDER_COMPLETE_ACTIVATE_ESIM: 'wabs74',
  },
  AUTH: {
    NEW_USER_REGISTER_ACCOUNT_LOGIN_SCREEN: '8ejw76',
    NEW_USER_SUBMIT_ACCOUNT_INFO: 'k64s8p',
    NEW_USER_ACCOUNT_CREATION_COMPLETE: 'lb5ehn',
    NEW_USER_OTP_VERIFY: '4yk3mr',
    NEW_USER_SUBMIT_MSISDN: 's1r3hj',
  },
  EXISTING_USER_BUNDLE_LIST_VIEWED: 'nf7gic',
  EXISTING_USER_BUNDLE_OTP_INITIATED: 'fw9wol',
  EXISTING_USER_BUNDLE_PURCHASE: 'qtc4hi',
  EXISTING_USER_SELECT_BUNDLE_DETAILS: 'dzkft8',
  EXISTING_USER_BUNDLE_PURCHASE_COMPLETE: '9yy1sp',
  EXISTING_USER_CHECKOUT_CLICK: 'u90sps',
  EXISTING_USER_SELECT_BUNDLE: '3jnmy2',
  EXISTING_USER_PAYMENT_METHOD_CONTINUE_CLICK: '1iw71s',
  EXISTING_USER_PROMO_CODE_APPLY: '650lhz',
  EXISTING_USER_GIFTING_BUNDLE_APPLY: 'fnabil',
  EXISTING_USER_OTP_VERIFY: '4lksuv',
};
